import { SpaceScale, FontSizes, FontWeights, Fonts, Radii, ColorPalette, ThemeColors, LetterSpacings } from '@adapt-design-system/tokens';
import { transformSpace, transformValueWithUnit, transformLineHeights, transformNameAndValue, transformColors } from '../scripts/transform-tokens';
export default {
  breakpoints: ['40em', '52em', '64em'],
  space: transformSpace(SpaceScale),
  fontSizes: transformValueWithUnit(FontSizes),
  lineHeights: transformLineHeights(FontSizes),
  fontWeights: transformNameAndValue(FontWeights),
  fonts: transformNameAndValue(Fonts),
  radii: transformValueWithUnit(Radii),
  colors: transformColors({
    palette: ColorPalette,
    theme: ThemeColors
  }),
  letterSpacings: transformValueWithUnit(LetterSpacings),
  shadows: {
    20: '0 1px 3px hsla(220, 3%, 19%, 0.14)',
    40: '0 1px 4px hsla(220, 3%, 19%, 0.14)',
    60: '0 2px 8px hsla(220, 3%, 19%, 0.14)',
    80: '0 4px 16px hsla(220, 3%, 19%, 0.14)',
    100: '0 7px 24px hsla(220, 3%, 19%, 0.14)'
  },
  sizes: {
    tinier: '16px',
    tiny: '32px',
    small: '48px',
    medium: '64px',
    large: '80px',
    dialogWidths: {
      sm: 440,
      md: 540,
      lg: 660,
      xl: 800
    }
  }
};